export default "__VITE_ASSET__DgNJlaYG__"